import { useMemo, useEffect } from 'react';
import { debounce } from 'lodash';

export function useDebouncedCallback<T extends (...args: any[]) => any>(callback: T, delay: number = 500): T {
  const debouncedFn = useMemo(() => debounce(callback, delay), [callback, delay]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      debouncedFn.cancel();
    };
  }, [debouncedFn]);

  return debouncedFn as T;
}
